<template>
    <div class="problem-card" :data-open="opened" :flipKey="opened">
        <div class="problem-card__problem" @click="toggle">
            <div class="problem-card__text">
                <slot name="problem"/>
            </div>

            <svg class="problem-card__toggle" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 0L7 5L12 0L14 1L7 8L0 1L2 0Z" fill="black"/>
            </svg>
        </div>


        <SlideUpDown class="problem-card__solution" :active="opened">
            <slot name="solution"/>
        </SlideUpDown>
    </div>
</template>

<script>
    import SlideUpDown from "vue-slide-up-down"

    export default {
        components: {
            SlideUpDown,
        },
        data(){
            return {
                opened: false,
            };
        },
        methods: {
            toggle(){
                this.opened = !this.opened;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use "~@scss/components/ProblemCard" as *;
</style>